import React, { Component } from "react";
import { FormattedMessage } from 'react-intl';

export class ImageDragAndDrop extends Component {
    constructor(props) {
        super(props);
        this.state = { dropActive: false };
        this.fileInputRef = React.createRef();
        this.dragCounter = 0;
    }

    isFileDrag = (e) => e.dataTransfer && Array.from(e.dataTransfer.types).includes('Files');

    onNativeDrop = (e) => {
        if (!this.isFileDrag(e)) return;
        e.preventDefault();
        this.dragCounter = 0;
        this.setState({ dropActive: false });
        const files = e.dataTransfer.files;
        if (files && files.length) this.props.handleDrop(files);
    }

    onDragEnter = (e) => {
        if (!this.isFileDrag(e)) return;
        e.preventDefault();
        this.dragCounter++;
        this.setState({ dropActive: true });
    }

    onDragOver = (e) => {
        if (!this.isFileDrag(e)) return;
        e.preventDefault();
    }

    onDragLeave = (e) => {
        if (!this.isFileDrag(e)) return;
        this.dragCounter--;
        if (this.dragCounter <= 0) {
            this.dragCounter = 0;
            this.setState({ dropActive: false });
        }
    }
    onClickZone = () => this.fileInputRef.current && this.fileInputRef.current.click();
    onFileChange = (e) => { if (e.target.files && e.target.files.length) this.props.handleDrop(e.target.files); }

    render() {
        const { dropActive } = this.state;
        return (
            <div
                className={`drop-zone${dropActive ? ' active' : ' text-muted'}`}
                onDrop={this.onNativeDrop}
                onDragEnter={this.onDragEnter}
                onDragOver={this.onDragOver}
                onDragLeave={this.onDragLeave}
                onClick={this.onClickZone}
            >
                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={this.onFileChange}
                />
                <div style={{ fontSize: '1.8rem' }}>
                    <i className={'fa-solid fa-cloud-upload-alt ' + (dropActive ? 'color-host' : ' ')} />
                </div>
                <p className="text-center mb-1">
                    {dropActive
                        ? <FormattedMessage id="ImageDragAndDrop.DropToUpload" />
                        : <FormattedMessage id="ImageDragAndDrop.DragOrClick" />
                    }
                </p>
                <p className="font_size_xxxs">
                    <FormattedMessage id="ImageDragAndDrop.MaxFileSize" />
                </p>
            </div>
        );
    }
}